const addressInfo = (listing) => {
  const result = []
  const keys = ['address', 'city', 'state', 'zipcode']
  for (const key of keys) {
    if (listing[key]) {
      result.push(listing[key])
    }
  }
  return result.join(', ')
}

const roomInfo = (listing) => {
  const result = []
  const keys = [
    { value: 'bedrooms', text: 'bedrooms' },
    { value: 'bathrooms', text: 'bathrooms' },
    { value: 'squareFeet', text: 'sqft' }
  ]
  for (const key of keys) {
    if (listing[key.value]) {
      result.push(`${listing[key.value]} ${key.text}`)
    }
  }
  return result
}

const roomInfoWithIcon = (listing) => {
  const result = []
  const keys = [
    { value: 'bedrooms', text: 'bedrooms', icon: 'icon-bedroom' },
    { value: 'bathrooms', text: 'bathrooms', icon: 'icon-bath' },
    { value: 'squareFeet', text: 'sqft', icon: 'icon-sqft' }
  ]
  for (const key of keys) {
    if (listing[key.value]) {
      result.push({
        text: `${listing[key.value]} ${key.text}`,
        icon: key.icon
      })
    }
  }
  return result
}

export {
  addressInfo,
  roomInfo,
  roomInfoWithIcon
}
